import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../../components/primitives/Panel';
import { TagEditor } from '../components/TagEditor';
import type { ProfileUpdate } from '../hooks/useProfileActions';
import { profileMessages as messages } from './profileMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** A typed country: two letters, upper case; anything else is dropped. */
export function normaliseCountry(value: string): string | null {
  const code = value.trim().toUpperCase();
  return /^[A-Z]{2}$/.test(code) ? code : null;
}

interface ProfileMarketsCardProps {
  markets: string[];
  onSave: (patch: ProfileUpdate) => void;
  disabled: boolean;
}

/** "Where your listeners are" (design outreach b1): the countries Plug adds local targets for. */
const ProfileMarketsCardComponent: React.FC<ProfileMarketsCardProps> = ({ markets, onSave, disabled }) => {
  const intl = useIntl();
  const save = useCallback((values: string[]) => onSave({ markets: values }), [onSave]);
  return (
    <Panel as="section">
      <PanelHead title={intl.formatMessage(messages.marketsTitle)} />
      <PanelBody>
        <div className={styles.stack}>
          {markets.length === 0 && <p className={styles.small}>{intl.formatMessage(messages.noMarkets)}</p>}
          <TagEditor
            values={markets}
            onChange={save}
            addLabel={intl.formatMessage(messages.addCountry)}
            highlightFirst={3}
            normalise={normaliseCountry}
            disabled={disabled}
            testId="profile-markets"
          />
          <p className={styles.small}>{intl.formatMessage(messages.marketsBody)}</p>
        </div>
      </PanelBody>
    </Panel>
  );
};

export const ProfileMarketsCard = TypedMemo(ProfileMarketsCardComponent);
